module.exports = __webpack_public_path__ + "img/140.9b474605.jpg";